import { memo } from 'react';
import { Box, Typography } from '@mui/material';
import { StatusIcon } from './StatusIcon';

export const Legend = memo(() => {
  const statuses = [
    { label: 'Incluido', indicator: 'INC' },
    { label: 'Cargo adicional', indicator: 'CHA' },
    { label: 'Según el segmento', indicator: 'MIX' },
    { label: 'No incluido', indicator: 'NOF' },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap',
        p: 1,
      }}
    >
      {statuses.map(({ label, indicator }) => (
        <Box
          key={indicator}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
          }}
        >
          <StatusIcon indicator={indicator} />
          <Typography sx={{ color: 'text.secondary', lineHeight: 0 }} variant='caption'>
            {label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
});
